import { withManifest } from '@godaddy/gasket-hcs';
import * as React from 'react';
import ApplicationFooter from '@ux/application-footer';
import '@ux/application-footer/styles';

/**
 * React Component to render the Footer.
 * This component must be present, but may return null if no footer is required.
 *
 * @param {Object} props The props for this component
 * @returns {React.ReactElement} JSX for footer
 */
// eslint-disable-next-line no-unused-vars
export function Footer(props) {
  return <ApplicationFooter { ...props } />;
}

/**
 * Export Footer with Manifest HOC.
 *
 * @component
 * @public
 */
export default withManifest(Footer, { componentName: 'footer' });
